import { render, staticRenderFns } from "./ProductChara.vue?vue&type=template&id=4ef06a1a&scoped=true"
import script from "./ProductChara.vue?vue&type=script&lang=js"
export * from "./ProductChara.vue?vue&type=script&lang=js"
import style0 from "./ProductChara.vue?vue&type=style&index=0&id=4ef06a1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef06a1a",
  null
  
)

export default component.exports